import type { ButtonVariantProps } from "./button-variants";

import { cn } from "@homeinstead/ui";
import { Slot } from "@radix-ui/react-slot";
import * as React from "react";
import { buttonVariants } from "./button-variants";

interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    ButtonVariantProps {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(buttonVariants({ className, size, variant }))}
        ref={ref}
        {...props}
      ></Comp>
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
